





























































import Modal from "../core/Modals/Modal.vue";
import ContactSelect from "../core/Forms/ContactSelect.vue";
import HtmlTextareaInput from "../core/Forms/HtmlTextareaInput.vue";
import { JournalEntry } from "../models/JournalEntry";
import { JournalApi } from "../api/JournalApi";
import FileUploader from "../core/Forms/FileUploader.vue";
import JournalObjectSelect from "../core/Forms/JournalObjectSelect.vue";

export default {
    name: "SendNotificationModal",
    components: {
        JournalObjectSelect,
        FileUploader,
        HtmlTextareaInput,
        ContactSelect,
        Modal,
    },
    props: {
        showModal: Boolean,
        parentId: Number,
        requestId: Number,
        forwardedFiles: Array,
        availableFiles: Array,
        defaultMessage: String,
        object: String,
        defaultSelectedObject: Object,
    },
    data() {
        return {
            title: "",
            entryParentId: null,
            selectedContact: null,
            selectedObject: null,
            messageBody: "",
            filesIds: [],
            photoIds: [],
            JournalApi: new JournalApi(),
            saving: false,
        };
    },
    methods: {
        closeModal(isSaved: boolean): void {
            this.saving = false;
            this.$emit("close-modal", isSaved);
        },
        updateFilesList: function (filesIds: Array<Number>): void {
            this.filesIds = filesIds;
        },
        updatePhotosList: function (photoIds: Array<Number>): void {
            this.photoIds = photoIds;
        },
        onUploadStart: function () {
            this.saving = true;
        },
        onUploadEnd: function () {
            this.saving = false;
        },
        saveData: function (): void {
            let self = this;

            if (!self.selectedContact || self.saving) return;

            self.saving = true;

            let newNotification = new JournalEntry({
                internal_recipient_id: self.selectedContact.id,
                description: self.messageBody,
                status: JournalEntry.EStatus.Pending,
                parent_id: self.entryParentId,
                communication_type:
                    JournalEntry.ECommunicationType.incoming_direct_message,
                filesIds: self.filesIds,
                photoIds: self.photoIds,
            });

            let object = (<any>JournalEntry.EObject)[self.object];
            if (object) {
                newNotification.comment_object = object;
                if (object === JournalEntry.EObject.intervention_request) {
                    newNotification.request_id = self.requestId;
                }
            } else if (self.selectedObject) {
                // no default object
                newNotification.object_id = self.selectedObject.id;
                if (
                    self.selectedObject.name ===
                    JournalEntry.ObjectName[
                        JournalEntry.EObject.intervention_request
                    ]
                ) {
                    newNotification.request_id = self.requestId;
                }
            } else {
                // no object selected
                newNotification.comment_object =
                    JournalEntry.EObject.incoming_notification;
            }

            return self.JournalApi.save(newNotification).then(function (res) {
                let sentConfirmation = new JournalEntry({
                    description: self.messageBody,
                    parent_id: self.entryParentId,
                    request_id: newNotification.request_id,
                    recipient_id: self.selectedContact.id,
                    recipient_type: JournalEntry.ERecipientType.Contact,
                    communication_type:
                        JournalEntry.ECommunicationType.outgoing_direct_message,
                    filesIds: self.filesIds,
                    photoIds: self.photoIds,
                });

                let object = (<any>JournalEntry.EObject)[self.object];
                if (object) {
                    sentConfirmation.comment_object = object;
                } else if (self.selectedObject) {
                    // no default object
                    sentConfirmation.object_id = self.selectedObject.id;
                } else {
                    // no object selected
                    sentConfirmation.comment_object =
                        JournalEntry.EObject.outgoing_notification;
                }

                if (object == JournalEntry.EObject.intervention_request) {
                    sentConfirmation.status = JournalEntry.EStatus.Pending;
                } else {
                    sentConfirmation.status = JournalEntry.EStatus.Closed;
                }

                return self.JournalApi.save(sentConfirmation).then(function (
                    res
                ) {
                    self.closeModal(true);
                });
            });
        },
    },
    watch: {
        parentId: {
            immediate: true,
            handler: function () {
                if (this.parentId) {
                    this.entryParentId = this.parentId;
                }
            },
        },
        defaultMessage: {
            immediate: true,
            handler: function () {
                if (this.defaultMessage) {
                    this.messageBody = this.defaultMessage;
                }
            },
        },
        defaultSelectedObject: {
            immediate: true,
            handler: function () {
                if (this.defaultSelectedObject) {
                    this.selectedObject = this.defaultSelectedObject;
                }
            },
        },
        object: {
            immediate: true,
            handler: function () {
                if (this.object === JournalEntry.EObject.intervention_request) {
                    this.title = "Demande d'intervention";
                } else {
                    this.title = "Notification directe";
                }
            },
        },
        showModal: {
            immediate: true,
            handler: function () {
                if (!this.showModal) {
                    this.selectedContact = null;
                    this.filesIds = [];
                }
            },
        },
    },
};
